module.exports = __webpack_public_path__ + "img/url-structure.1b236536.png";